import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { ProfileMenuComponent, type ProfileMenuUser } from '@sbe-spinoff-client/app-shell';
import { StaffOidcAuthService } from './staff-oidc-auth.service';

/**
 * 헤더 우측 계정 드롭다운 — 실제 렌더링은 `@sbe-spinoff-client/app-shell`의
 * `ProfileMenuComponent`(인증 서비스에 의존하지 않는 순수 프레젠테이션 컴포넌트)에 위임한다.
 * `apps/schoolbell-e/staff-web`의 `StaffProfileMenuComponent`(`StaffAuthService` 어댑터)와
 * 같은 패턴(2026-08-12, 로그인 가능한 모든 앱이 같은 드롭다운을 쓰도록 통일). sbe-commerce와
 * sbe-sms의 staff-web이 byte-identical한 어댑터를 각자 갖고 있던 걸 여기로 합쳤다
 * (2026-08-12 code-review 발견) — `/staff/auth/me`는 `staffId`와 선택 `name`을
 * 반환하므로(백엔드별 나머지 필드는 다르지만 이 두 필드는 공통) 여기서 안전하게 좁혀 쓸 수 있다.
 *
 * `StaffOidcAuthService.me`는 `unknown` 캐시 signal이다(구체 타입은 앱마다 `isAuthorized`로
 * 좁혀 쓰는 설계) — name(없으면 staffId)만 뽑아 `ProfileMenuUser`로 매핑한다. email·phone 은 이 세션에
 * 없어 생략한다.
 */
@Component({
  selector: 'app-staff-profile-menu',
  imports: [ProfileMenuComponent],
  template: `<sbe-profile-menu [user]="user()" (logoutRequested)="logoutRequested.emit()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffProfileMenuComponent {
  private readonly auth = inject(StaffOidcAuthService);

  readonly logoutRequested = output<void>();

  protected readonly user = computed<ProfileMenuUser | null>(() => {
    const me = this.auth.me() as { name?: string | null; staffId?: string | null } | null;
    return me ? { name: me.name ?? me.staffId } : null;
  });
}
